export default __webpack_public_path__ + "static/media/ivInfusionIcon.320dae20.svg";